const NotFoundPage = () => {
	return (
		<div className="vh-100 d-flex justify-content-center align-items-center">
			<div className="container">
				<div className="row d-flex justify-content-center">
					<div className="col-12 col-md-8 col-lg-5">
						<div className="card card-login">
							<div className="card-body p-5">
								<h1 className="error-404">404</h1>
								<h3 className="text-align-center">Recurso no encontrado</h3>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default NotFoundPage;